import { render } from "./Aside.vue?vue&type=template&id=b318417e"
import script from "./Aside.vue?vue&type=script&lang=ts"
export * from "./Aside.vue?vue&type=script&lang=ts"
script.render = render

export default script